<template>
  <div>
    <breadcrumb/>
    <post-list category="Factoring-Nuestros Objetivos y Avances-Logro de Objetivos"></post-list>
  </div>
</template>

<script>
  import PostList from "@/components/Posts/PostList";
  import Breadcrumb from "@/components/General/Breadcrumb";
  export default {
    components: {
      PostList,
      Breadcrumb
    }
  };
</script>
